// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3ZUyt","label":"SetPasswdForm_label__2X7bq"};